import Events from "./events.js";

class EventContext {
    constructor() {
        this._objectEvents = new WeakMap();
    }

    getEvents(object, createIfMissing = true) {
        let events = this._objectEvents.get(object);

        if (!events && createIfMissing) {
            events = new Events();
            this._objectEvents.set(object, events);
        }

        return events;
    }
}

export default EventContext;
